import { Redirect, Route, Switch } from 'react-router-dom';
import Loading from '../../Abstracts/Components/Loading';
import useInsuranceLicense from '../../Hooks/UseInsuranceLicense';
import FoodLicenseAddSection from './FoodLicenseAddSection';
import FoodLicenseSummarySection from './FoodLicenseSummarySection';
import InsuranceLicenseFormHeader from './InsuranceLicenseFormHeader';
import InsuranceLicenseHeader from './InsuranceLicenseHeader';
import LiabilityInsuranceAddSection from './LiabilityInsuranceAddSection';
import LiabilityInsuranceSummarySection from './LiabilityInsuranceSummarySection';

export default function InsuranceLicenseContent() {
	const { data, isLoading, addLiabilityInsurance, removeLiabilityInsurance, addFoodLicense, removeFoodLicense } =
		useInsuranceLicense();

	if (isLoading) {
		return <Loading message="Loading insurance and licenses" />;
	}

	if (!data) {
		return (
			<div className="insurance-license-empty">
				<p>Unable to load your insurance and licenses right now.</p>
			</div>
		);
	}

	const sortedPolicies = [...data.publicLiability].sort(
		(a, b) => Number(b.PublicLiabilityInsuranceExpiry ?? 0) - Number(a.PublicLiabilityInsuranceExpiry ?? 0),
	);
	const sortedFoodLicenses = [...data.foodLicenses].sort(
		(a, b) => Number(b.FoodLicenseExpiry ?? 0) - Number(a.FoodLicenseExpiry ?? 0),
	);

	return (
		<div className="insurance-license-content">
			<Switch>
				<Route exact path="/">
					<InsuranceLicenseHeader
						title="Insurance and licenses"
						subhead="Add and manage your public liability insurance policies and food licenses."
					/>
					<LiabilityInsuranceSummarySection
						policies={sortedPolicies}
						nextBookings={data.nextBookings}
						removeLiabilityInsurance={removeLiabilityInsurance}
					/>

					<FoodLicenseSummarySection
						licenses={sortedFoodLicenses}
						councilRegions={data.councilRegions}
						regionsRequired={data.regionsRequired}
						removeFoodLicense={removeFoodLicense}
					/>
				</Route>

				<Route exact path="/add/public-liability-insurance">
					<InsuranceLicenseFormHeader
						title="Add public liability insurance"
						backTo="/"
						backLabel="Back to insurance and licenses"
					/>
					<LiabilityInsuranceAddSection addLiabilityInsurance={addLiabilityInsurance} />
				</Route>

				<Route exact path="/add/food-license">
					<InsuranceLicenseFormHeader
						title="Add food license"
						backTo="/"
						backLabel="Back to insurance and licenses"
					/>
					<FoodLicenseAddSection councilRegions={data.councilRegions} addFoodLicense={addFoodLicense} />
				</Route>

				<Redirect to="/" />
			</Switch>
		</div>
	);
}
